<p-dialog
  header="Nouvelle affaire vivier"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '520px' }"
  styleClass="pool-create-dialog"
  (onHide)="close()"
>
  <div class="create-form">
    <!-- Nom du client -->
    <div class="field">
      <label for="pcd-lastname">Nom du client *</label>
      <input
        id="pcd-lastname"
        type="text"
        pInputText
        [(ngModel)]="customerLastname"
        placeholder="Ex. Dupont"
        autocomplete="off"
        autofocus
      />
    </div>

    <!-- Adresse du chantier (BAN) -->
    <div class="field address-field">
      <label for="pcd-address">Adresse du chantier *</label>
      <span class="address-input-wrap">
        <input
          id="pcd-address"
          type="text"
          pInputText
          [ngModel]="addressQuery"
          (ngModelChange)="onAddressQueryChange($event)"
          (keydown)="onAddressKeydown($event)"
          placeholder="N°, rue, code postal, ville…"
          autocomplete="off"
        />
        @if (addressSearchLoading) {
          <i class="pi pi-spin pi-spinner address-loading"></i>
        } @else if (selectedAddress) {
          <i class="pi pi-check-circle address-valid"></i>
        }
      </span>
      @if (addressSearchOpen) {
        <ul class="address-results" role="listbox">
          @for (result of addressResults; track result.label; let i = $index) {
            <li
              role="option"
              [class.is-active]="i === addressActiveIndex"
              (mousedown)="$event.preventDefault(); selectAddress(result)"
              (mouseenter)="addressActiveIndex = i"
            >
              <i class="pi pi-map-marker"></i>
              {{ result.label }}
            </li>
          }
        </ul>
      }
      @if (!selectedAddress && addressQuery.trim().length > 0) {
        <small class="field-hint">
          Sélectionnez une adresse dans la liste (géolocalisation requise pour
          le calcul des tournées).
        </small>
      }
    </div>

    <!-- Produits (catalogue commun) -->
    <div class="field">
      <label for="pcd-products">Produit(s) *</label>
      <p-multiSelect
        inputId="pcd-products"
        [options]="products"
        [ngModel]="selectedProducts"
        (ngModelChange)="onProductsChange($event)"
        optionLabel="name"
        [filter]="true"
        [showToggleAll]="false"
        [loading]="productsLoading"
        placeholder="Sélectionner les produits"
        appendTo="body"
        styleClass="w-full"
      ></p-multiSelect>

      @if (selectedProducts.length > 0) {
        <ul class="selected-products">
          @for (product of selectedProducts; track product.id) {
            <li>
              <span class="sp-name">
                {{ product.abbreviation || product.name }}
              </span>
              <span class="sp-qty">
                <button
                  type="button"
                  (click)="changeQuantity(product, -1)"
                  [disabled]="getQuantity(product) <= 1"
                >
                  −
                </button>
                <span>{{ getQuantity(product) }}</span>
                <button type="button" (click)="changeQuantity(product, 1)">
                  +
                </button>
              </span>
            </li>
          }
        </ul>
        @if (totalDurationLabel) {
          <small class="field-hint duration-hint">
            <i class="pi pi-hourglass"></i>
            Durée de service estimée : {{ totalDurationLabel }}
          </small>
        }
      }
    </div>

    <!-- Marché de l'affaire (défaut : Maison individuelle) -->
    <div class="field">
      <label for="pcd-market">Marché *</label>
      <p-dropdown
        inputId="pcd-market"
        [options]="marketTypes"
        [(ngModel)]="selectedMarketTypeId"
        optionLabel="name"
        optionValue="id"
        placeholder="Sélectionner le marché"
        appendTo="body"
        styleClass="w-full"
      ></p-dropdown>
    </div>

    <!-- Fenêtre souhaitée (optionnel) : n° de semaine ou dates précises -->
    <div class="wished-block">
      <div class="field week-field">
        <label for="pcd-week">Semaine souhaitée (optionnel)</label>
        <div class="week-input-row">
          <span class="week-prefix">S</span>
          <input
            id="pcd-week"
            type="number"
            min="1"
            max="53"
            pInputText
            [ngModel]="wishedWeek"
            (ngModelChange)="onWishedWeekChange($event)"
            placeholder="n°"
          />
          @if (wishedWeekHint) {
            <span class="week-hint">
              <i class="pi pi-calendar"></i>
              {{ wishedWeekHint }}
            </span>
          }
        </div>
        @if (wishedWeekError) {
          <small class="field-error">{{ wishedWeekError }}</small>
        }
      </div>

      <div class="field-row">
        <div class="field">
          <label for="pcd-wished-start">Souhaité à partir du</label>
          <p-datepicker
            inputId="pcd-wished-start"
            [(ngModel)]="wishedPlanningStartDate"
            (ngModelChange)="onWishedDatesEdited()"
            [dateFormat]="'dd/mm/yy'"
            [showIcon]="true"
            [readonlyInput]="true"
            [showClear]="true"
            appendTo="body"
            placeholder="jj/mm/aaaa"
            styleClass="w-full"
          ></p-datepicker>
        </div>
        <div class="field">
          <label for="pcd-wished-end">Jusqu'au</label>
          <p-datepicker
            inputId="pcd-wished-end"
            [(ngModel)]="wishedPlanningEndDate"
            (ngModelChange)="onWishedDatesEdited()"
            [dateFormat]="'dd/mm/yy'"
            [showIcon]="true"
            [readonlyInput]="true"
            [showClear]="true"
            [minDate]="wishedPlanningStartDate ?? undefined"
            appendTo="body"
            placeholder="jj/mm/aaaa"
            styleClass="w-full"
          ></p-datepicker>
        </div>
        <div class="field">
          <label for="pcd-deadline">Échéance</label>
          <p-datepicker
            inputId="pcd-deadline"
            [(ngModel)]="planningDeadline"
            [dateFormat]="'dd/mm/yy'"
            [showIcon]="true"
            [readonlyInput]="true"
            [showClear]="true"
            appendTo="body"
            placeholder="jj/mm/aaaa"
            styleClass="w-full"
          ></p-datepicker>
        </div>
      </div>
    </div>

    @if (submitError) {
      <p class="submit-error">
        <i class="pi pi-exclamation-circle"></i>
        {{ submitError }}
      </p>
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Annuler"
      severity="secondary"
      [outlined]="true"
      [disabled]="submitting"
      (click)="close()"
    ></p-button>
    <p-button
      label="Ajouter au vivier"
      icon="pi pi-plus"
      [loading]="submitting"
      [disabled]="!canSubmit"
      (click)="submit()"
    ></p-button>
  </ng-template>
</p-dialog>
